import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addproposaltowishlist } from "../../../../../../../redux/posts/action";
import PostNotFound from "../../../../../../CustomComponents/AllLoader/PostNotFound";
import ViewProfilePopup from "../../../../../../Common/ViewProfilePopup";
import ProjectHireRequestModel from "../../../../../../Common/ProjectHireRequestModel";
import {
  hitPostChat,
} from "../../../../../../../redux/chatandnotification/action";
import ProfilePic from "../../../../../../../assests/imgs/Profileplaceholder.svg";
import { getJobProjectProposalsStatusLabel } from "../../../../../../../assests/extention/commonfunction";
import RoleLabel from "../../../../../../Common/RoleLabel";
import CustomReactQuillDescription from "../../../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import { updateProjectProposal } from "../../../../../../../redux/project/action";
import { type } from "@testing-library/user-event/dist/cjs/utility/type.js";
import ConfirmModal from "../../../../../../Common/ConfirmModal";
import { decodeHtml } from "../../../../../../../assests/extention/commonfunction";

export default function MineJobAllProposals({ posts, directpayment }) {
  const [loading, setLoading] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [proposal, setProposal] = useState([]);
  const [modal, setModal] = useState(false);
  const [profiledetails, setprofiledetails] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [proid, setproid] = useState("");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [selectedCancelId, setSelectedCancelId] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);


  const comformhireExpert = (id) => {
    navigate(`/${lan}/projectcontract/${id}`, { state: { owner: true } });
  };

  const letChat = (item) => {
    const data = {
      post_id: posts?.id,
      user_id: item?.user_id,
    };
    const hitcatapidata = {
      type: "1",
      post_id: posts?.id,
      user_id: item?.user_id,
      message: "",
      image: "",
    };

    // dispatch(hitPostChat(hitcatapidata, setLoading));
    navigate(`/${lan}/account/chats/`, { state: { userdetails: data } });
  };

  const saveToWishlist = (id) => {
    dispatch(addproposaltowishlist(id, posts?.id));
  };

  useEffect(() => {
    setProposal(posts?.proposal || []);
  }, [posts]);

  const viewprofile = (item) => {
    setModal(true);
    setprofiledetails(item);
  };

  const confirmCancelOffer = (xid) => {
    setSelectedCancelId(xid);
    setConfirmModalOpen(true);
  };

  const cancelSendOffer = () => {
    if (selectedCancelId) {
      const data = {
        type: '1',
        id: selectedCancelId,
        status: '4'
      }
      dispatch(updateProjectProposal(data, setLoading))
      setConfirmModalOpen(false);
      setSelectedCancelId(null);
    }
  };


  return (
    <div className="project-section project-details p-0">
      {modal && (
        <ViewProfilePopup
          profiledetails={profiledetails}
          posts={posts}
          setModal={setModal}
          modal={modal}
          comformhireExpert={comformhireExpert}
        />
      )}
      {modal1 && (
        <ProjectHireRequestModel
          posts={posts}
          setModal1={setModal1}
          modal1={modal1}
          proid={proid}
        />
      )}

      <ConfirmModal
        isOpen={confirmModalOpen}
        toggle={() => setConfirmModalOpen(!confirmModalOpen)}
        title="Cancel Offer"
        message={`Are you sure you want to cancel this offer?
As per admin configuration, each user is allowed a limited number of cancellations. You have used ${profile?.settings?.total_cancelation || 0} out of ${profile?.settings?.max_cancelation || 0} allowed cancellations.`}
        onConfirm={cancelSendOffer}
        showConfirmModel={true}
      />

      <div className="post-details">
        <div className="all-proposal-row">
          {Array.isArray(proposal) && proposal?.length > 0 ? (
            proposal?.map((item, index) => (
              <div className="all-proposal" key={index}>
                {console.log(item, "the item")}
                <div className="proposal-first">
                  <div
                    className="proposal-left"
                    onClick={() => viewprofile(item)}
                  >
                    <img src={item?.profile_image ? item?.profile_image : ProfilePic} alt="" />
                    <div>
                      <h5>
                        {item?.first_name} {item?.last_name}
                        <span>
                          <i className="fa-solid fa-star"></i>
                          {item?.expert_rating || 0} ({item?.expert_comment_count || 0} reviews)
                        </span>
                      </h5>
                      <p>{decodeHtml(item?.designation)}</p>
                    </div>
                  </div>

                  <div className="expert-right">
                    <button
                      className="btn message-btn"
                      onClick={() => {
                        letChat(item);
                      }}
                    >
                      Chat with <RoleLabel role_type={item?.role_type} />
                    </button>
                    <button
                      disabled={item?.status != "1"}
                      className="btn message-btn active"
                      onClick={() => {
                        comformhireExpert(item?.id);
                      }}
                    >
                      {getJobProjectProposalsStatusLabel(item?.status)}
                    </button>
                    {(item?.status == "3") && (
                      <button
                        className="btn message-btn active"
                        onClick={() => {
                          confirmCancelOffer(item?.id);
                        }}
                      >
                        Cancel Offer
                      </button>
                    )}
                    {
                      (
                        (
                          item?.status == "3" &&
                          posts?.type == "1" &&
                          Array.isArray(posts?.milestones) &&
                          posts.milestones.length > 0 &&
                          posts.milestones[0]?.payment_status == "0" &&
                          item?.payment_status == "0"
                        ) ||
                        (
                          item?.status == "23" &&
                          item?.payment_status == "0"
                        )
                      ) && (
                        <button
                          className="btn message-btn active"
                          onClick={() => directpayment(item)}
                        >
                          Pay
                        </button>
                      )
                    }
                    <button
                      className="btn menu-btn"
                      onClick={() => {
                        saveToWishlist(item?.id);
                      }}
                    >
                      {item.wishlist == 1 ? (
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/heart-active.svg`}
                          alt=""
                        />
                      ) : (
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/heart.svg`}
                          alt=""
                        />
                      )}
                    </button>
                  </div>
                </div>
                <h3>Cover letter</h3>
                <p className="cover-p"><CustomReactQuillDescription value={item?.message} /></p>
                <div className="photoshop">
                  {Array.isArray(item?.skills) &&
                    item.skills.map((skill, index) => (
                      <p key={index}>{decodeHtml(skill?.title)}</p>
                    ))}
                </div>
              </div>
            ))
          ) : (
            <PostNotFound title={"Proposal not found"} />
          )}
        </div>
      </div>
    </div>
  );
}
